import React from 'react'
import { Typography } from 'antd'

const { Title } = Typography

const Header = (props) => {
  let headerText = ''

  if (props.title && props.title != '') {
    headerText += props.title
  }

  if (props.extendedtitle && props.extendedtitle != '') {
    headerText += ` ${props.extendedtitle}`
  }

  if (props.subtitle && props.subtitle != '') {
    headerText += ` - ${props.subtitle}`
  }

  return (
    <Title level={5} id="header-component-details">
      {headerText}
    </Title>
  )
}

export default Header
